import type { AppData, User } from '../../types';
import { apiJson } from './client';

export async function getMe() {
  return apiJson<{ user: User | null }>('/api/auth/me');
}

export async function login(email: string, password: string) {
  return apiJson<{ user: User }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export async function register(email: string, password: string) {
  return apiJson<{ user: User }>('/api/auth/register', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
}

export async function logout() {
  return apiJson<{ ok: boolean }>('/api/auth/logout', { method: 'POST' });
}

export async function getProgress() {
  return apiJson<{ data: AppData | null; updatedAt: number | null }>('/api/progress');
}

export async function putProgress(data: AppData) {
  return apiJson<{ ok: true; updatedAt: number }>('/api/progress', {
    method: 'PUT',
    body: JSON.stringify(data),
  });
}
